import configFile from './javascript/utils/global/configFile.js';

const envConfig = configFile(process.env.REACT_APP_ENV, process.env.INSTANCE);
const API = `${envConfig.fsm.endpoint}/fse/territories-enabled`;
const loadApp = () => Promise.resolve(import('./root'));

function init() {
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
  }
  if (process.env.NODE_ENV === 'development') {
    loadApp();
  } else if (!window.location.href.includes('/v2')) {
    try {
      const xhr = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        try {
          if (xhr.readyState !== 4) return;
          const response = JSON.parse(xhr.response);
          if (response?.territoriesEnabled) {
            window.location.replace(
              `${window.location.origin}/v2/index.html${
                window.location.search.includes('?') ? '' : '?'
              }${window.location.search}`,
            );
          } else {
            loadApp();
          }
        } catch (e) {
          loadApp();
        }
      };

      const sessionToken = JSON.parse(
        localStorage.getItem('ggSession'),
      ).accessToken;
      xhr.open('GET', API);
      xhr.setRequestHeader('session_token', sessionToken);
      xhr.send();
    } catch (e) {
      loadApp();
    }
  } else {
    loadApp();
  }
}
init();
